import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import { Menu } from "lucide-react";
import ScopingAISidebar from "./ScopingAISidebar";
import { Button } from "../../../foundation/altzero_base/base/components/ui/button";
import { useIsMobile } from "../../../foundation/altzero_base/base/components/ui/use-mobile";

interface ScopingAILayoutProps {
  children: React.ReactNode;
}

export default function ScopingAILayout({ children }: ScopingAILayoutProps) {
  const location = useLocation();
  const isMobile = useIsMobile();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // Collapse sidebar when creating proposals
  const shouldCollapseSidebar = location.pathname.includes('/new') ||
    location.pathname.includes('/proposal-editor') ||
    location.pathname.includes('/documents/new') ||
    location.pathname.includes('/quick-proposal');

  return (
    <div className="flex h-screen bg-gray-50">
      {/* Sidebar - Desktop fixed, Mobile drawer */}
      <ScopingAISidebar
        forceCollapsed={shouldCollapseSidebar}
        mobileOpen={mobileMenuOpen}
        onMobileClose={() => setMobileMenuOpen(false)}
      />

      {/* Main Content */}
      <div className="flex-1 flex flex-col w-full md:ml-0">
        {/* Mobile Menu Button */}
        {isMobile && (
          <div className="fixed top-4 left-4 z-40">
            <Button
              variant="outline"
              size="icon"
              onClick={() => setMobileMenuOpen(true)}
              className="bg-white shadow-lg"
            >
              <Menu className="h-5 w-5" />
            </Button>
          </div>
        )}

        <main className="flex-1 min-h-0 overflow-y-auto p-4 md:p-6">{children}</main>
      </div>
    </div>
  );
}
